// Only include file types that are supported by the AI model
export const ALLOWED_FILE_TYPES = {
  text: ['text/plain'],
  image: ['image/png', 'image/jpeg', 'image/jpg', 'image/gif', 'image/webp'],
  document: ['application/pdf'],
} as const;

export const ALL_ALLOWED_FILE_TYPES = [
  ...ALLOWED_FILE_TYPES.text,
  ...ALLOWED_FILE_TYPES.image,
  ...ALLOWED_FILE_TYPES.document,
] as const;

export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB

export function isAllowedFileType(mediaType: string): boolean {
  return (ALL_ALLOWED_FILE_TYPES as readonly string[]).includes(mediaType);
}

export function getAcceptString(): string {
  return 'text/plain,image/png,image/jpeg,image/jpg,image/gif,image/webp,application/pdf';
}

// Data upload constants (for tabular data files uploaded to org storage)
export const ALLOWED_DATA_EXTENSIONS = ['.csv', '.parquet', '.pq'] as const;
export const MAX_DATA_FILE_SIZE = 5 * 1024 * 1024 * 1024; // 5GB

export function isAllowedDataFile(fileName: string): boolean {
  const lowerName = fileName.toLowerCase();
  return ALLOWED_DATA_EXTENSIONS.some((ext) => lowerName.endsWith(ext));
}
